import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {NumberFieldConfig} from './number-field.config';
import {buildNumberFieldValidators} from './number-field.builder';

export const numberFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = buildNumberFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});
        return;
    }

    if (updateFieldConfig.hasOwnProperty('maxValue')
        && (currentFieldConfig as NumberFieldConfig).maxValue !== (updateFieldConfig as NumberFieldConfig).maxValue
    ) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
        const validators = buildNumberFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }
    if (updateFieldConfig.hasOwnProperty('minValue')
        && (currentFieldConfig as NumberFieldConfig).minValue !== (updateFieldConfig as NumberFieldConfig).minValue
    ) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
        const validators = buildNumberFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }
};
